<template>
  <div>
    <h2 style="text-align: center" v-if="unit">
      Editing "{{ unit.friendlyName }}" Config
    </h2>

    <div class="row no-gutters">
      <div class="col-md-6">
        <b-button variant="primary" @click="close">Go Back...</b-button>
      </div>
      <div class="col-md-6" style="text-align: end">
        <b-button variant="danger" v-b-modal.deleteMod>Delete</b-button>
      </div>
    </div>
    <b-modal
      centered
      id="deleteMod"
      title="Warning!!"
      @ok="deleteUnit"
      body-bg-variant="dark"
      ok-title="Yes, I'm sure!"
    >
      <p>
        You are about to delete this unit from the system. Your settings will
        not be recoverable!! Are you sure?
      </p>
    </b-modal>

    <b-form @submit.prevent="onSubmit" v-if="unit">
      <div class="row no-gutters p-2" v-if="$store.getters.isAdmin">
        <div class="col-dmd-6 pr-2">
          <b-form-group label-cols="auto" label="Unit Admin Group">
            <b-form-input id="group" v-model="unit.group" />
          </b-form-group>
        </div>
        <div class="col-dmd-6 pr-2">
          <b-form-group
            label-cols="auto"
            label="GoLive Software Version to Push"
          >
            <b-form-input id="version" v-model="unit.pushedVersion" />
          </b-form-group>
        </div>
      </div>

      <div class="row no-gutters p-2">
        <div class="col-dmd-6 pr-2">
          <b-form-group label-cols="auto" label="Unit Friendly Name">
            <b-form-input id="friendlyName" v-model="unit.friendlyName" />
          </b-form-group>
        </div>
        <div class="col-dmd-6">
          <b-form-group label-cols="auto" label="Device ID">
            <b-form-input
              id="unitId"
              placeholder="Include all those zeros!"
              v-model="unit.unitId"
            />
          </b-form-group>
        </div>
      </div>

      <div class="row no-gutters p-2">
        <div class="col-md-4 pr-2">
          <b-form-group label-cols="auto" label="BASS Display Name:">
            <b-form-input
              id="dispName"
              v-model="unit.config.sipAccounts[0].displayName"
            />
          </b-form-group>
        </div>

        <div class="col-md-4 pr-2">
          <b-form-group label-cols="auto" label="BASS Address:">
            <b-form-input
              id="bassAdd"
              v-model="unit.config.sipAccounts[0].username"
            />
          </b-form-group>
        </div>

        <div class="col-md-4">
          <b-form-group label-cols="auto" label="BASS Password:">
            <b-form-input
              type="password"
              id="bassPass"
              v-model="unit.config.sipAccounts[0].password"
            />
          </b-form-group>
        </div>
      </div>

      <div class="row no-gutters p-2">
        <b-form-group
          label-cols="auto"
          label="Bit Rate"
          label-for="numberOfHosts"
        >
          <b-form-spinbutton
            id="bitrate"
            v-model="unit.config.sipAccounts[0].opusBitrate"
            min="16000"
            max="10000000"
            step="16000"
            size="sm"
            inline
          />
        </b-form-group>

        <b-form-group
          label-cols="auto"
          label="Stereo"
          label-for="isHostConnectionOnly"
          class="pl-2"
        >
          <b-form-select
            v-model="unit.config.sipAccounts[0].opusStereo"
            :options="stereoOptions"
          ></b-form-select>
        </b-form-group>
      </div>

      <div class="row no-gutters">
        <div class="col-md-6 p-2">
          <b-form-group label-cols="auto" label="Speedify Username:">
            <b-form-input
              id="speedyUser"
              v-model="unit.config.speedifyAccount.speedyUser"
            />
          </b-form-group>
        </div>

        <div class="col-md-6 p-2">
          <b-form-group label-cols="auto" label="Speedify Password:">
            <b-form-input
              id="speedyName"
              type="password"
              v-model="unit.config.speedifyAccount.speedyPass"
            />
          </b-form-group>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col-md-2 p-2">
          <b-form-checkbox
            id="answermode"
            v-model="unit.config.sipAccounts[0].answermode"
            value="auto"
            unchecked-value="manual"
          >
            Auto-answer (v1.1.3+)
          </b-form-checkbox>
        </div>

        <div class="col-md-5 p-2">
          <b-form-checkbox
            id="headless"
            v-model="unit.config.guiSetup.headless"
            value="true"
            unchecked-value="false"
          >
            Headless (runs sip client at startup for screenless applications)
            (v1.1.0+)
          </b-form-checkbox>
        </div>

        <div class="col-md-5 p-2">
          <b-form-checkbox
            id="talkBack"
            v-model="unit.config.guiSetup.talkBack"
            value="true"
            unchecked-value="false"
          >
            Talkback / Cough (adds latching and momentary mute/unmute)(v1.1.0+)
          </b-form-checkbox>
        </div>
      </div>

      <div class="card bg-dark">
        <table class="table table-dark">
          <thead>
            <tr>
              <th>Contact Name (as displayed on the buttons)</th>
              <th>Bass Address</th>
            </tr>
          </thead>
          <tbody>
            <tr
              div
              v-for="(cont, counter) in unit.config.contacts"
              v-bind:key="counter"
            >
              <td>
                <b-form-group>
                  <b-form-input v-model="cont.name" />
                </b-form-group>
              </td>
              <td>
                <b-form-group>
                  <b-form-input v-model="cont.address" />
                </b-form-group>
              </td>
              <td @click="deleteContact(counter)">Remove</td>
            </tr>

            <tr>
              <div class="row no-gutters p-2">
                <button
                  type="button"
                  class="btn btn-success"
                  @click="addContact"
                >
                  Add New Contact
                </button>

                <div class="pl-2">
                  <b-button
                    v-b-toggle.collapse-1
                    style="
                                font-size: small
                                border: none;
                                background-color: transparent;
                                color: white;
                            "
                  >
                    <span class="when-open">
                      <b-icon-chevron-bar-contract
                    /></span>
                    <span class="when-closed">
                      <b-icon-chevron-bar-expand />
                    </span>
                    Defaults
                  </b-button>
                </div>
                <div class="pl-2">
                  <b-button
                    v-b-toggle.collapse-2
                    style="
                                font-size: small
                                border: none;
                                background-color: transparent;
                                color: white;
                            "
                  >
                    <span class="when-open">
                      <b-icon-chevron-bar-contract
                    /></span>
                    <span class="when-closed">
                      <b-icon-chevron-bar-expand />
                    </span>
                    Download/Upload
                  </b-button>
                </div>
              </div>
            </tr>

            <tr>
              <b-collapse id="collapse-1" class="mt-2">
                <div class="row no-gutters p-2">
                  <div class="pr-2">
                    <button
                      type="button"
                      class="btn btn-primary btn-block"
                      @click="addContacts(traffic)"
                    >
                      Add London Traffic
                    </button>
                  </div>

                  <div class="pr-2">
                    <button
                      type="button"
                      class="btn btn-primary btn-block"
                      @click="addContacts(loc)"
                    >
                      Add London LOC
                    </button>
                  </div>

                  <div class="pr-2">
                    <button
                      type="button"
                      class="btn btn-primary btn-block"
                      @click="addContacts(salf)"
                    >
                      Add Salford
                    </button>
                  </div>
                </div>
              </b-collapse>
            </tr>
          </tbody>
        </table>
      </div>
      <b-collapse id="collapse-2" class="mt-2">
        <div class="row no-gutters p-2">
          <div class="pr-2">
            <b-button @click="downloadContacts">Download Contacts</b-button>
          </div>
          <div class="pr-2">
            <b-button @click="upload">Upload Contacts</b-button>
          </div>

          <div class="pr-2">
            <input type="file" id="uploadJSON" accept="application/json" />
          </div>
        </div>
      </b-collapse>

      <div class="col-md-6 pt-2">
        <b-form-group label-cols="auto" label="Speed Dial Contact for GPI:">
          <b-form-input id="speedDialContact" v-model="unit.config.speedDialContact" />
        </b-form-group>
      </div>

      <div class="row no-gutters p-2">
        <b-button type="submit" variant="danger" :disabled="state != 'done'">
          Update!
          <b-spinner small v-show="state != 'done'" />
        </b-button>

        <div class="pl-2">
          <b-button type="button" variant="primary" @click="close">
            Go back without saving
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<style scoped>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>

<script>
import api from "@/api";

import { BIconChevronBarExpand, BIconChevronBarContract } from "bootstrap-vue"; //import ContactTable from "@/components/ContactTable";
//<ContactTable :v-if="unit.config.contacts" :contacts="unit.config.contacts" />

export default {
  name: "EditUnit",

  props: {
    unitId: {
      type: String,
    },
  },

  data: function() {
    return {
      state: "done",
      unit: null,
      image: null,
      errors: [],
      stereoOptions: [
        { value: "yes", text: "Yes" },
        { value: "no", text: "No" },
      ],
      traffic: [
        {
          name: "IPCOM 108",
          type: "SIP",
          address: "0551114108@bass.bbc.co.uk",
        },
        {
          name: "IPCOM 109",
          type: "SIP",
          address: "0551114109@bass.bbc.co.uk",
        },
        {
          name: "IPCOM 110",
          type: "SIP",
          address: "0551114110@bass.bbc.co.uk",
        },
        {
          name: "IPCOM 111",
          type: "SIP",
          address: "0551114111@bass.bbc.co.uk",
        },
        {
          name: "IPCOM 112",
          type: "SIP",
          address: "0551114112@bass.bbc.co.uk",
        },
      ],
      loc: [
        {
          name: "IPCOM 208",
          type: "SIP",
          address: "0551114148@bass.bbc.co.uk",
        },
        {
          name: "IPCOM 209",
          type: "SIP",
          address: "0551114149@bass.bbc.co.uk",
        },
        {
          name: "IPCOM 210",
          type: "SIP",
          address: "0551114150@bass.bbc.co.uk",
        },
        {
          name: "IPCOM 211",
          type: "SIP",
          address: "0551114151@bass.bbc.co.uk",
        },
        {
          name: "IPCOM 212",
          type: "SIP",
          address: "0551114152@bass.bbc.co.uk",
        },
      ],
      salf: [
        {
          name: "Salford 1",
          type: "SIP",
          address: "0551114081@bass.bbc.co.uk",
        },
        {
          name: "Salford 2",
          type: "SIP",
          address: "0551114082@bass.bbc.co.uk",
        },
        {
          name: "Salford 3",
          type: "SIP",
          address: "0551114083@bass.bbc.co.uk",
        },
        {
          name: "Salford 4",
          type: "SIP",
          address: "0551114084@bass.bbc.co.uk",
        },
        {
          name: "Salford 5",
          type: "SIP",
          address: "0551114085@bass.bbc.co.uk",
        },
      ],
    };
  },

  methods: {
    onSubmit() {
      this.updateUnit(this.unit);
    },

    close() {
      this.$emit("close");
    },

    async deleteUnit() {
      let result = await api.units.deleteUnit(this.unitId);
      console.log(result);
      this.close();
    },

    addContacts(contacts) {
      this.unit.config.contacts = this.unit.config.contacts.concat(contacts);
      console.log(this.unit.config.contacts);
    },

    async updateUnit(unit) {
      this.state = "saving";
      unit = await this.setUnit(unit);
      if (unit) {
        let result = await api.units.update(unit);
        let { error, message, results } = result;
        if (error) console.error(message);
      }
      this.state = "done";
      this.close();
    },

    async setUnit(unit) {
      let {
        key,
        group,
        unitId,
        friendlyName,
        userId,
        config,
        pushedVersion,
        version,
        guiSetup,
      } = unit;

      config = JSON.stringify(unit.config);
      return (unit = {
        key,
        group,
        unitId,
        friendlyName,
        userId,
        config,
        pushedVersion,
        version,
        guiSetup,
      });
    },

    async loadUnit(unitId) {
      let result = await api.units.get(unitId);
      let { error, message, results } = result;

      if (error) {
        console.error(message);
        return;
      }

      let config = JSON.parse(results.unit.config);
      config.sipAccounts[0].opusBitrate = parseInt(
        config.sipAccounts[0].opusBitrate
      );
      if (!config.guiSetup) {
        config.guiSetup = { headless: false, talkBack: false };
      }
      if (!config.answermode) config.answermode = "manual";
      results.unit.config = config;
      this.unit = results.unit;
      console.log(this.unit);
    },

    addContact() {
      this.unit.config.contacts.push({
        name: "Button Name",
        type: "SIP",
        address: "example@bass.bbc.co.uk",
      });
    },
    deleteContact(counter) {
      this.unit.config.contacts.splice(counter, 1);
    },
    downloadContacts() {
      var filename = "GoLiveContacts.json";
      var element = document.createElement("a");

      element.setAttribute(
        "href",
        "data:application/json;charset=utf-8," +
          encodeURIComponent(JSON.stringify(this.unit.config.contacts))
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },

    upload() {
      var fileInput = document.getElementById("uploadJSON");
      var file = fileInput.files[0];
      var reader = new FileReader(file);
      var plainTextJSON;

      reader.onload = (e) => {
        this.image = e.target.result;

        plainTextJSON = reader.result;
        var c = JSON.parse(plainTextJSON);
        this.unit.config.contacts = c;

        console.log(c);
      };

      reader.readAsText(file);
    },
  },

  mounted() {
    this.loadUnit(this.unitId);
  },

  components: {
    BIconChevronBarExpand,
    BIconChevronBarContract,
  },
};
</script>
